import {Fragment} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import EventSinglePage from '../../components/BlogDetails/BlogSingle.js';
import Footer from '../../components/footer/Footer.js';
import Navbar2 from '../../components/Navbar2/Navbar2.js';
import img from '../../images/contact.jpg';

const BlogDetailsFull =() => {

    return(
        <Fragment>
            <Navbar2 hclass={'wpo-header-style-1'} />
            <PageTitle pageTitle={'Latest News'} pagesub={'Event'} img={img}/> 
            <EventSinglePage blLeft={'d-none'} blRight={'col-lg-10 offset-lg-1'}/>
            <Footer />
            <Scrollbar/>
        </Fragment>
    )
};
export default BlogDetailsFull;